<template>
  <div>
    <appQuoteViewCom
      :propsData="getQuoteSingle"
      :quoteType="'leads'"
      :leadSource="'RDL'"
    ></appQuoteViewCom>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import appQuoteViewCom from '../../../components/quote/quoteViewCom.vue'
export default {
  name: 'LeadsQuoteView',
  components: {
    appQuoteViewCom
  },
  data() {
    return {
      quoteId: this.$route.params.quoteId
    }
  },
  computed: {
    ...mapGetters(['getQuoteSingle'])
  },
  methods: {
    ...mapActions(['fetchQuoteSingle'])
  },
  async created() {
    await this.fetchQuoteSingle({
      id: this.quoteId,
      quoteType: 'leads'
    })
  }
}
</script>
